import typography from"./typography.module.css";var labelMedium=typography.labelMedium;export{labelMedium};